export const GEO_DATA_REQUEST = 'GEO_DATA_REQUEST';
export const GEO_DATA_SUCCESS = 'GEO_DATA_SUCCESS';
export const GEO_DATA_FAILURE = 'GEO_DATA_FAILURE';

export const PROVIDER_DATA_REQUEST = 'PROVIDER_DATA_REQUEST';
export const PROVIDER_DATA_SUCCESS = 'PROVIDER_DATA_SUCCESS';
export const PROVIDER_DATA_FAILURE = 'PROVIDER_DATA_FAILURE';

export const LOOKUP_DATA_REQUEST = 'LOOKUP_DATA_REQUEST';
export const LOOKUP_DATA_SUCCESS = 'LOOKUP_DATA_SUCCESS';
export const LOOKUP_DATA_FAILURE = 'LOOKUP_DATA_FAILURE';

export const LOAD_PROVIDER_DATA = 'LOAD_PROVIDER_DATA';

export const TEXT_DATA_REQUEST = 'TEXT_DATA_REQUEST';
export const TEXT_DATA_SUCCESS = 'TEXT_DATA_SUCCESS';
export const TEXT_DATA_FAILURE = 'TEXT_DATA_FAILURE';

export const LOOKUP_REFERENCE_DATA_REQUEST = 'LOOKUP_REFERENCE_DATA_REQUEST';
export const LOOKUP_REFERENCE_DATA_SUCCESS = 'LOOKUP_REFERENCE_DATA_SUCCESS';
export const LOOKUP_REFERENCE_DATA_FAILURE = 'LOOKUP_REFERENCE_DATA_FAILURE';

export const SERVICE_DATA_REQUEST = 'SERVICE_DATA_REQUEST';
export const SERVICE_DATA_SUCCESS = 'SERVICE_DATA_SUCCESS';
export const SERVICE_DATA_FAILURE = 'SERVICE_DATA_FAILURE';

